export default "__VITE_ASSET__BML6qCGU__"